import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErrorMessage, normalizeOperators } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";

// Mostra solo il nome della città, senza prefissi IMRCC/MRSC (il valore reale
// resta invariato per login e database).
function cityLabel(op) {
  return String(op || "").replace(/^\s*(IMRCC|\d*\s*MRSC)\s+/i, "").trim() || op;
}

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [operators, setOperators] = useState([]);
  const [loadingOps, setLoadingOps] = useState(true);
  const [opsError, setOpsError] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let active = true;
    setLoadingOps(true);
    api.get("/operators")
      .then(({ data }) => { if (active) { setOperators(normalizeOperators(data)); setOpsError(null); } })
      .catch((e) => { if (active) setOpsError(apiErrorMessage(e)); })
      .finally(() => { if (active) setLoadingOps(false); });
    return () => { active = false; };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error("Seleziona un operatore e inserisci la password");
      return;
    }
    setSubmitting(true);
    try {
      await login(username, password);
      toast.success("Accesso effettuato");
      navigate("/");
    } catch (err) {
      toast.error(apiErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center relative overflow-hidden bg-[#0A2647]">
      <div className="w-full max-w-md mx-4 p-8"
      data-testid="login-card">
      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="space-y-2">
          {opsError ? (
            <div className="text-sm text-[#ff8a8a] bg-[#0A2647] border border-[#D32F2F] rounded-sm p-2"
              data-testid="operators-error">
              Errore caricamento operatori: {opsError}
            </div>
          ) : (
            <Select value={username} onValueChange={setUsername} disabled={loadingOps}>
              <SelectTrigger id="operator" data-testid="operator-select"
                className="bg-[#0A2647] border-[#1E5AA8] text-white">
                <SelectValue placeholder={loadingOps ? "Caricamento…" : "Seleziona operatore"} />
              </SelectTrigger>
              <SelectContent className="bg-[#113259] border-[#1E5AA8] text-white max-h-72">
                {operators.map((op) => (
                  <SelectItem key={op} value={op} data-testid={`operator-option-${op}`}
                    className="focus:bg-[#1E5AA8] focus:text-white">
                    {cityLabel(op)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        </div>

          <div className="space-y-2">
            <Input id="password" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••" autoComplete="current-password"
              data-testid="password-input"
              className="bg-[#0A2647] border-[#1E5AA8] text-white placeholder:text-[#4b6a8a]" />
          </div>
          <button type="submit" className="hidden" aria-hidden="true" tabIndex={-1} />
        </form>
      </div>
    </div>
  );
}
